import { below } from 'utils/breakpoint';
import { error } from 'Mui/styles/color';

export const generateMuiTextFieldCustomColorStyle = color => `
    color: ${color};
    .MuiInputBase-root, .MuiIconButton-root {
        font-size: inherit;
        color: inherit;
    }
    .MuiInput-underline:before,
    .MuiInput-underline:after,
    .MuiInput-underline:hover:not(.Mui-disabled):before {
        border-bottom-color: inherit;
    }
    .MuiInput-underline.Mui-error:after {
        border-bottom-color: ${error.color};
    }
    .MuiInputBase-input.MuiInput-input {
        text-align: inherit;
    }
`;

export const generateMuiSelectCustomColorStyle = color => `
    color: ${color};
    & .MuiInputBase-root {
        font-size: inherit;
    }
    & .MuiInput-underline:not(.Mui-error):before,
    & .MuiInput-underline:not(.Mui-error):after,
    & .MuiInput-underline:not(.Mui-error):hover:not(.Mui-disabled):before {
        border-bottom-color: ${color};
    }
    & .MuiSelect-root.Mui-disabled {
        opacity: 0.5;
    }
    & .MuiSvgIcon-root.MuiSelect-icon {
        color: ${color};
    }
`;

export const sectionWrapperStyle = `
    padding: 32px 48px 16px;
    ${below('sm')} {
        padding: 32px 16px 16px;
    }
`;

export const textInputStyle = `
    line-height: 1.1875;
    padding: 7px 0;
    letter-spacing: 0.5px;
`;

export const errorHintStyle = `
    text-align: right;
    font-size: 0.8125rem;
    line-height: 2rem;
    transition: all .1s linear;
    opacity: 0;
    color: ${error.color};
    margin-left: 5px;
`;

export const shortWidthSectionErrorHintStyle = `
    ${errorHintStyle}
    ${below('sm')} {
        float: right;
    }
`;

export const fullWidthSectionErrorHintStyle = `
    ${errorHintStyle}
    float: right;
`;

export function getFeverFormTextAlign(alignType = 0) {
    return {
        0: 'left',
        1: 'center',
        2: 'right'
    }[alignType];
}
